module.exports = "<div class=\"loader\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/loader/loader.html
// module id = 61
// module chunks = 0